module.exports = __webpack_public_path__ + "static/media/Prashant.b76107a9.JPG";